import { useAuth } from '@/lib/auth';
import { useRoleNewsFeed } from '@/lib/news/use-role-news-feed';
import { useFeedVisit } from '@/lib/news/feed-seen';
import { isFeedItemUnread } from '@/lib/news/feed-unread';
import { NewsFeed } from '@/components/news/news-feed';
import { CreatePrivateLiveLink } from '@/features/private-live/private-lives-section';
import { FeedRefreshButton } from '@/features/news-refresh/feed-refresh-button';
import { PullToRefreshZone } from '@/features/news-refresh/pull-to-refresh-zone';
import { useFeedAutoRefresh } from '@/features/news-refresh/use-feed-auto-refresh';
import type { FeedItem } from '@/components/news/types';

export function ParentNewsPage() {
  const { user } = useAuth();
  const {
    items,
    authorsById,
    doneAssignmentKeys,
    isLoading,
    hasMore,
    isFetchingMore,
    loadMore,
    refresh,
    isRefreshing,
  } = useRoleNewsFeed('parent');
  const seenAtAtOpen = useFeedVisit();
  const isUnread = (item: FeedItem) =>
    seenAtAtOpen !== undefined && isFeedItemUnread(item, seenAtAtOpen, user?.id);

  useFeedAutoRefresh(refresh);

  return (
    <div className="pb-safe mx-auto max-w-2xl px-4 py-6 sm:py-8">
      <div className="mb-6">
        <div className="flex items-start justify-between gap-3">
          <h1 className="font-display text-ink-900 text-2xl font-extrabold">Feed</h1>
          <FeedRefreshButton onRefresh={refresh} isRefreshing={isRefreshing} />
        </div>
        <p className="text-ink-500 mt-1 font-sans text-sm">
          Devoirs, défis et résultats de tes enfants.
        </p>
        <CreatePrivateLiveLink className="mt-3" />
      </div>

      <PullToRefreshZone onRefresh={refresh} isRefreshing={isRefreshing}>
        <NewsFeed
          items={items}
          isLoading={isLoading}
          hasMore={hasMore}
          isFetchingMore={isFetchingMore}
          onLoadMore={loadMore}
          viewerRole="parent"
          viewerId={user?.id}
          authorsById={authorsById}
          doneAssignmentKeys={doneAssignmentKeys}
          isUnread={isUnread}
        />
      </PullToRefreshZone>
    </div>
  );
}
